
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/student/landing/contents/material/[materialId]",
      function () {
        return require("private-next-pages/[lang]/student/landing/contents/material/[materialId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/student/landing/contents/material/[materialId]"])
      });
    }
  